module.exports = __webpack_public_path__ + "img/avatar17_11zon.ce3e3009.webp";